import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';

import styles from './IssueItem.module.sass';

const IssueItem = ({ categoriesExtra, count, name, posts, slug }) => {
  const featuredImageUrl = categoriesExtra?.featureimage?.sourceUrl;
  const issueLink = count === 1 ? posts?.nodes?.[0]?.slug : `/issues/${slug}`;

  return (
    <Link href={issueLink} passHref>
      <a>
        <div className={styles.issueItem}>
          <div className={styles.overlay}>
            <span>{name}</span>
          </div>
          {featuredImageUrl && (
            // eslint-disable-next-line @next/next/no-img-element
            <img className={styles.image} alt={name} src={featuredImageUrl} />
          )}
        </div>
      </a>
    </Link>
  );
};

export default IssueItem;

IssueItem.propTypes = {
  categoriesExtra: PropTypes.object,
  count: PropTypes.number,
  name: PropTypes.string,
  posts: PropTypes.object,
  slug: PropTypes.string,
};
